const useBusinessPerformancePermissionsList = (
  permissionsGroup, studioPermissionsToIterate, isUser
) => {

  const studioPermissionsToIterate1 = studioPermissionsToIterate[5];
  const studioPermissionsToIterate2 = studioPermissionsToIterate[6];
  const studioPermissionsToIterate3 = studioPermissionsToIterate[7];
  const studioPermissionsToIterate4 = studioPermissionsToIterate[8];

  const group1 = permissionsGroup.filter(g => g.groupId === "9");
  const group2 = permissionsGroup.filter(g => g.groupId === "10");
  const group3 = permissionsGroup.filter(g => g.groupId === "11");
  const group4 = permissionsGroup.filter(g => g.groupId === "12");

  if (
    group1.length === 0 ||
            group2.length === 0 ||
            group3.length === 0 ||
            group4.length === 0
  ) {
    return null;
  }

  const permissionsList1 = group1[0].permissions;
  const permissionsList2 = group2[0].permissions;
  const permissionsList3 = group3[0].permissions;
  const permissionsList4 = group4[0].permissions;

  const permissionsList1WithCompanyRaw = permissionsList1.map((perm) => {
    return studioPermissionsToIterate1.map(stPerm => {
      if (perm.functionId === stPerm.functionId){
        return  {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList2WithCompanyRaw = permissionsList2.map((perm) => {
    return studioPermissionsToIterate2.map(stPerm => {
      if (perm.functionId === stPerm.functionId){
        return  {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList3WithCompanyRaw = permissionsList3.map((perm) => {
    return studioPermissionsToIterate3.map(stPerm => {
      if (perm.functionId === stPerm.functionId){
        return  {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });
  const permissionsList4WithCompanyRaw = permissionsList4.map((perm) => {
    return studioPermissionsToIterate4.map(stPerm => {
      if (perm.functionId === stPerm.functionId){
        return  {
          ...perm,
          companyPermission: stPerm.isActive === true ? true : false
        };
      }
      return perm;
    });
  });

  const permissionsList1WithCompany = permissionsList1WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList2WithCompany = permissionsList2WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList3WithCompany = permissionsList3WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });
  const permissionsList4WithCompany = permissionsList4WithCompanyRaw.map(x => {
    return x.find(y => {
      return y.hasOwnProperty("companyPermission");
    });
  });

  const permissionsListStructure = [
    {
      listToIterate: isUser ? permissionsList1WithCompany : permissionsList1,
      index: 5,
      listLabel: "permissionsList1"
    },
    {
      listToIterate: isUser ? permissionsList2WithCompany : permissionsList2,
      index: 6,
      listLabel: "permissionsList2"
    },
    {
      listToIterate: isUser ? permissionsList3WithCompany : permissionsList3,
      index: 7,
      listLabel: "permissionsList3"
    },
    {
      listToIterate: isUser ? permissionsList4WithCompany : permissionsList4,
      index: 8,
      listLabel: "permissionsList4"
    }
  ];

  return permissionsListStructure;
};

export default useBusinessPerformancePermissionsList;